module.exports = __webpack_public_path__ + "img/image16.13162bc6.webp";